<template>
  <div class="g-wrapper">
    <div class="g-main">
      <img src="../assets/guestTitle.png" alt="" class="u-guestTitle" />
      <p class="u-hint">嘉宾按议程排序</p>
    </div>

    <div class="g-guestList">
      <div
        class="m-guestItem"
        @click="showGuestLayer(index)"
        v-for="(item, index) in guestList"
        :key="index"
      >
        <div class="u-imgBox">
          <img :src="item.detail['img_嘉宾照片']" alt="" />
        </div>
        <div class="u-gusetName">{{ item.detail["姓名"] }}</div>
        <div class="u-guestPos">{{ item.detail["职位"] }}</div>
      </div>
      <div  class="m-guestItem" @click.stop="isNavShow = true">
        <img src="../assets/moreGuest.png" alt="" class="u-moreGuest" />
      </div>
    </div>

    <!-- 弹窗 -->
    <div class="g-layer" v-show="isLayerShow">
      <div class="m-gusetDesc">
        <div class="u-imgBox">
          <img :src="geustLayer.detail['img_嘉宾照片']" alt="" />
        </div>
        <div class="u-gusetName">{{ geustLayer.detail["姓名"] }}</div>
        <div class="u-guestPos">{{ geustLayer.detail["职位"] }}</div>
        <img src="../assets/icon3.png" alt="" class="u-icon3" />
        <div class="u-guestIntr">
          {{ geustLayer.detail["简介"] }}
        </div>
      </div>
      <img
        src="../assets/icon4.png"
        alt=""
        class="u-icon4"
        @click="isLayerShow = false"
      />
    </div>

    <!-- <div
      :class="isNavShow ? 'g-forumNav' : 'g-forumNav hide'"
      @click.stop="hideLayer($event)"
      id="nav"
    >
      <ul>
        <li
          v-for="(item, index) in forumList"
          :key="index"
          @click.stop="changeforunIndex(index)"
          :class="activeforumIndex == index ? 'active' : ''"
        >
          {{ item.name }}
        </li>
      </ul>
    </div> -->

    <div class="g-navLayer" v-show="isNavShow" @click.stop="hideLayer($event)" id="nav">
       <ul class="m-navList">
         <li
          v-for="(item, index) in forumList"
          :key="index"
          @click.stop="changeforunIndex(index)"
          :class="activeforumIndex == index ? 'active' : ''"
        >
          {{ item.name }}
        </li>
       </ul>

       <img src="../assets/icon4.png" alt="" class="u-icon4_layer" @click.stop="isNavShow =false">
    </div>

    <img src="../assets/logo.png" alt="" class="u-logo" />
  </div>
</template>

<script>
import forumData from "../data/forumData.js";
export default {
  data() {
    return {
      isLayerShow: false,
      guestList: [],
      geustLayer: {
        detail: {
          img_嘉宾照片: "",
          姓名: "",
          简介: "",
          职位: "",
          论坛: "",
        },
      },
      forumList: forumData,
      activeforumIndex: 0,
      guestListAll: [],
      isNavShow: false,
    };
  },
  methods: {
    showGuestLayer(index) {
      if (this.guestList[index].detail["简介"] == "") {
        return false;
      }
      this.isLayerShow = true;
      this.geustLayer = this.guestList[index];
    },
    closeNav(event) {
      console.log(event.currentTarget);
      this.isNavShow = false;
    },
    changeforunIndex(index) {
      this.activeforumIndex = index;
      this.getforumGuest(index);
      this.isNavShow = false;
      $(".g-wrapper").scrollTop(0)
    },
    hideLayer(event) {
      if (event.currentTarget.id == "nav") {
        this.isNavShow = !this.isNavShow;
      }
    },
    getforumGuest(index) {
      let guestArray = [];
      let that = this;
      let fiflteName = "";
      this.guestListAll.map((item) => {
        if (
          that.forumList[that.activeforumIndex].name.includes(
            item.detail["论坛"]
          )
        ) {
          guestArray.push(item);
        }
      });

      that.guestList = guestArray;
      
    },
    getGuestList() {
      let that = this;
      $.ajax({
        url: "http://www.nbd.com.cn/zhuanti/activity_enters.json?activity_name=2021%E5%B3%B0%E4%BC%9A%E5%98%89%E5%AE%BE&status=0",
        methods: "get",
        success: function (data) {
          console.log(data);
          that.guestListAll = data.infos;
          // that.geustLayer = data.infos[0];
          that.getforumGuest(0);
        },
      });
    },
  },
  mounted() {
    this.getGuestList();
  },
};
</script>

<style lang='scss' scoped>
.u-guestTitle {
  width: 501px;
  height: 118px;
  display: block;
  margin: 30px auto;
}
.g-guestList {
  width: 735px;
  margin: 0 auto;
  background: #fff;
  padding: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.m-guestItem {
  width: 280px;
  color: #202020;
  font-size: 30px;
  margin-bottom: 80px;
}
.u-imgBox {
  width: 245px;
  height: 245px;
  border-radius: 50%;
  background: #e5e5e5;
  margin: 0 auto;
  overflow: hidden;
  img {
    max-width: 100%;
  }
}
.u-gusetName {
  font-weight: bolder;

  padding-bottom: 15px;
  border-bottom: 1px solid #ab1010;
}
.u-guestPos {
  line-height: 1.4;
  margin-top: 15px;
}
.g-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
}
.m-gusetDesc {
  padding: 45px 70px;
  width: 615px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .u-gusetName {
    text-align: center;
    margin-top: 25px;
  }
  .u-guestPos {
    text-align: center;
  }
}
.u-icon3 {
  width: 100%;
  height: 7px;
  margin: 20px auto;
  display: block;
}
.u-guestIntr {
  text-indent: 2em;
  color: #202020;
  font-size: 30px;
  line-height: 1.4;
  height: 400px;
  overflow-y: auto;
  text-align: justify;
}
.u-icon4 {
  height: 73px;
  width: 73px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
}
.g-forumNav {
  width: 683px;
  height: 910px;
  background: url("../assets/icon8.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  right: 0;
  top: 150px;
  padding-left: 133px;
  box-sizing: border-box;
  transition: all 0.5s;
  &.hide {
    right: -575px;
  }
  ul {
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    padding: 15px 0;
    box-sizing: border-box;
    li {
      padding-bottom: 30px;
      border-bottom: 1px solid #e35b5d;
      font-size: 34px;
      color: #fff;
      list-style: none;
      &.active {
        font-weight: bolder;
      }
      &:last-child {
        border: none;
      }
    }
  }
}
.u-hint {
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}
.u-moreGuest {
  width: 241px;
  height: 353px;
}

.g-navLayer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
}

.m-navList {
  background-image: linear-gradient(to right, #dc2326, #d8393b , #c52a2c);
  padding:35px;
  border-radius: 5px;
  width: 590px;
  box-sizing: border-box;
  margin: 50px auto;
  li {
      padding-bottom: 30px;
      border-bottom: 1px solid #e45b5d;
      font-size: 30px;
      color: #fff;
      list-style: none;
      margin-bottom: 35px;
      text-align: center;
      &.active {
        font-weight: bolder;
        border-bottom: 1px solid #ffb6b6;
      }
      &:last-child {
        border: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
}
.u-icon4_layer {
  width: 73px;
  height: 73px;
  display: block;
  margin: 30px auto;
}
</style>